// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3kZtV","selects":"Documents_selects__IYm8n"};